// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

const borderWidths = [1, 2, 4]

export default borderWidths
